import React, { useEffect, useState } from 'react';
import { Control, FieldErrors, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { direccionGarantia } from '../../models/garantias';
import ModalInmobiliarias from './modalInmobiliarias';
import inmobiliariaDto from '../../../maestros/inmobiliarias/models/inmobiliariaDto';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { Grid2 } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import InputRut from '../../../../components/inputs/yup/materialui/inputRut';
import InputText from '../../../../components/inputs/yup/materialui/inputText';

interface FormProps {
    control: Control<direccionGarantia, undefined>;
    setValue: UseFormSetValue<direccionGarantia>;
    isEditing: boolean;
    errors: FieldErrors<direccionGarantia>;
    trigger: UseFormTrigger<direccionGarantia>;
    esVigente?: boolean;
    isReadonlyWithPermission?: boolean;
}

const PropiedadNueva: React.FC<FormProps> = ({
    control,
    setValue,
    isEditing,
    errors,
    trigger,
    esVigente,
    isReadonlyWithPermission
}) => {

    const [show, setShow] = useState<boolean>(false);
    const [tablaSeleccionada, setTablaSeleccionada] = useState<inmobiliariaDto>();

    useEffect(() => {
        if (tablaSeleccionada) {
            setValue('nombreInmobiliaria', tablaSeleccionada?.nombre, { shouldDirty: true });
            setValue('rutInmobiliaria', tablaSeleccionada?.rut, { shouldDirty: true });
            trigger('rutInmobiliaria');
            trigger('nombreInmobiliaria');
        }
    }, [tablaSeleccionada, setValue, trigger]);

    return (
        <>
            <Grid2 container spacing={2} mt={2}>
                <Grid2 size={{ xs: 12, lg: 4 }}>
                    <InputRut
                        label="Inmobiliaria RUT"
                        name="rutInmobiliaria"
                        control={control}
                        error={errors.rutInmobiliaria}
                        // readonly={!isEditing}
                        // disabled={!isEditing || isEditing && esVigente}
                        readonly
                    />
                </Grid2>

                <Grid2 size={{ xs: 12, lg: 7 }}>
                    <InputText
                        label="Nombre"
                        name="nombreInmobiliaria"
                        control={control}
                        error={errors.nombreInmobiliaria}
                        readonly
                    />
                </Grid2>

                <Grid2 size={{ xs: 12, lg: 1 }} sx={{ mt: 3 }}>
                    <MButton
                        type='button'
                        variant='contained'
                        color='primary'
                        children={<SearchIcon fontSize="small" />}
                        onClick={() => setShow(true)}
                        disabled={isReadonlyWithPermission}
                    />
                </Grid2>
            </Grid2 >
            <ModalInmobiliarias
                show={show}
                onHide={() => setShow(false)}
                setTablaSeleccionada={setTablaSeleccionada}
            />
        </>
    );
};

export default PropiedadNueva;